<template>
    <ux-form ref="form" :data="formData" width="300px" :colon="true" :rules="rules" label-width="56px" data-automation="addGroup" @close="close" @confirm="confirm">
        <ux-form-item  prop="group_ids">
           <ux-radio v-model="formData.group_ids" :options="options"></ux-radio>
        </ux-form-item>
      
    </ux-form>
</template>

<script>
    export default {
      props: {
        data: {
          type: Object,
          default: () => {
            return {
              group_ids: '', //用户组
            };
          }
        }
      },
      data() {
        return {
          options: [],
          formData: JSON.parse(JSON.stringify(this.data)),
          rules: this.$rul.register(this),
        };
      },
      created() {
        this.getGroup();
      },
      methods: {
        /**
             * 获取用户组
             */
        getGroup() {
          this.$api.system.getGroup().then(res => {
            if (res.code == 10000) {
              // 转换成用户组单选框所需要的格式
              let result = res.data.map(item => {
                return {
                  label: item.group_name,
                  value: item.id

                };
              });
              this.options = result;
            }
          });
        },

        /**
             * 取消回调
             */
        close() {
          this.$uxModal.hide();
        },

        /**
             * 确认回调
             */
        confirm() {
          this.$refs['form'].validate((valid) => {
            if (valid) {
              const joinGroupArr = Array.of(this.formData.group_ids);
              this.$emit('confirm', joinGroupArr);
            }
          });
        },
      }
    };
</script>